"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function handleDeleteBetslipBet(state, action) {
    var betslipBetId = action.payload.betslipBetId;
    var betslipBets = state.betslipBets, betslipOdds = state.betslipOdds, chosenBetslipBetId = state.chosenBetslipBetId;
    var betslipBet = betslipBets.get(betslipBetId);
    if (!betslipBet)
        return state;
    var betslipOddIds = betslipBet.betslipOddIds;
    var nextBetslipOdds = betslipOdds.deleteAll(betslipOddIds);
    var nextBetslipBets = betslipBets.delete(betslipBetId);
    var nextChosenBetslipBetId = betslipBetId === chosenBetslipBetId ? null : chosenBetslipBetId;
    return state
        .set('chosenBetslipBetId', nextChosenBetslipBetId)
        .set('betslipBets', nextBetslipBets)
        .set('betslipOdds', nextBetslipOdds);
}
exports.default = handleDeleteBetslipBet;
//# sourceMappingURL=handleDeleteBetslipBet.js.map